import { User } from './AuthContext';

export function getUserName(user: User | null): string {
  if (!user) return '';

  return user.firstName && user.lastName
    ? `${user.firstName} ${user.lastName}`
    : user.email || '';
}
